// Keep in sync with backend ALL_SECTIONS (helper/functions.ts)
export const ALL_SECTIONS = [
  "Vendor Management",
  "Inventory Management",
  "Purchase Order",
  "Documents",
  "Purchase Entry",
  "Processing",
  "Account",
];

export const PATH_SECTION = [
  ["/vendor-management", "Vendor Management"],
  ["/inventory", "Inventory Management"],
  ["/purchase-order", "Purchase Order"],
  ["/purchase-entry", "Purchase Entry"],
  ["/processing-unit-list", "Processing"],
  ["/invoice", "Account"],
  ["/documents", "Documents"],
  ["/account", "Account"],
  ["/user-role", "admin"],
];
